module.exports = __webpack_public_path__ + "static/media/Petromin.47a4141a.jpg";